import { BackOfficeReportPreview } from "@mcleod/settlement/src/BackOfficeReportPreview";
import { AutogenLayoutMiscInvoiceProcessingPrintReview } from "./autogen/AutogenLayoutMiscInvoiceProcessingPrintReview";
import { MiscInvoiceProcessingStepperProps } from "./MiscInvoiceProcessingStepper";
import { Api, Currency, CurrencySettings, CurrencyUtil } from "@mcleod/core";
import { ReportData, ReportPreviewTabSource } from "@mcleod/components";
import { MiscInvoiceProcessingUtil } from "./MiscInvoiceProcessingUtil";

export class MiscInvoiceProcessingPrintReview extends AutogenLayoutMiscInvoiceProcessingPrintReview {
    public reportPreviewPrintReview: BackOfficeReportPreview;

    override onLoad() {
        this.initializePrintReviewPanel();
    }

    initializePrintReviewPanel() {
        this.reportPreviewPrintReview = new BackOfficeReportPreview("Invoice Print Review", true);
        this.panelReportPreview.add(this.reportPreviewPrintReview);
    }

    async printInvoices(props: MiscInvoiceProcessingStepperProps) {
        this.labelLoadingImages.visible = props.sendToImaging;
        const response = await Api.post("lme/ar/print-misc-invoices", { misc_invoices: props.selectedRows, send_to_imaging: props.sendToImaging });
        const data = response?.data[0];
        this.labelLoadingImages.visible = false;

        const totalInvoicedAmount = new Currency({ ...data?.total_invoiced_amount });
        this.mainDataSource.activeRow?.updateCurrency("total_invoiced_amount", totalInvoicedAmount);
        this.labelTotalInvoicedAmount.text = CurrencyUtil.formatCurrency(totalInvoicedAmount);
        this.mainDataSource.activeRow?.set("invoice_count", (data?.invoice_count as number) || 0);
        this.labelInvoiceCount.text = data?.invoice_count || "0";

        if (CurrencySettings.getSingleton().multiCurrencyEnabled()) {
            this.labelTotalInvoicedAmountCaption.text = "Net Amount (Functional):";
            const multicurrencyTotals = data?.multicurrency_totals || [];
            MiscInvoiceProcessingUtil.populateMulticurrencyTotals(this.mainDataSource, this.panelMulticurrencyTotals, multicurrencyTotals);
        }

        this.reportPreviewPrintReview.beginSearch();
        const exceptionTab = MiscInvoiceProcessingUtil.createExceptionTab(data.exceptions_list);

        const tabSources: ReportPreviewTabSource[] = [
            ...data.all_report_data as ReportData[],
            exceptionTab
        ];
        this.reportPreviewPrintReview.endSearch(MiscInvoiceProcessingUtil.cleanTabSources(tabSources));
    }
}
